import { initializeApp, type FirebaseOptions } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

const FIREBASE_BY_ENV: Record<string, FirebaseOptions> = {
  TEST: {
    apiKey: "AIzaSyDXYcJjgQ-DB_4_xh0AbqhhhjVWlkoV1_s",
    authDomain: "asepha-test-f27bc.firebaseapp.com",
    projectId: "asepha-test-f27bc",
    storageBucket: "asepha-test-f27bc.firebasestorage.app",
    messagingSenderId: "971043426079",
    appId: "1:971043426079:web:8b880b06e8b31e92406a2a",
    measurementId: "G-YC9F39SEJM",
  },
  PRODUCTION: {
    apiKey: "AIzaSyAe00pem_7TVspzQMsW6IhPWuamxNfLQh0",
    authDomain: "asepha-redi.firebaseapp.com",
    projectId: "asepha-redi",
    storageBucket: "asepha-redi.firebasestorage.app",
    messagingSenderId: "89572064440",
    appId: "1:89572064440:web:172a27394dd6683978c84d",
    measurementId: "G-SN0139N41K",
  },
  DEVELOPMENT: {
    apiKey: "AIzaSyD6qMzmSYUrtfrW6U8AJ6k5iQ1VqAjZCko",
    authDomain: "asepha-dev.firebaseapp.com",
    projectId: "asepha-dev",
    storageBucket: "asepha-dev.firebasestorage.app",
    messagingSenderId: "179521777603",
    appId: "1:179521777603:web:aee91c3723a43a5514d776",
    measurementId: "G-ZVPPXD90NY",
  },
};

function getFirebaseConfig(): FirebaseOptions {
  const environment = import.meta.env.VITE_ENVIRONMENT || "DEVELOPMENT";

  if (environment === "TEST") {
    return FIREBASE_BY_ENV.TEST;
  }
  if (environment === "PRODUCTION") {
    return FIREBASE_BY_ENV.PRODUCTION;
  }
  return FIREBASE_BY_ENV.DEVELOPMENT;
}

const firebaseConfig = getFirebaseConfig();
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const ALLOWED_EMAIL_DOMAINS = ["asepha.ai", "carelinkos.com"];

export const isAllowedEmail = (email: string | null | undefined) => {
  const domain = email?.split("@")[1]?.toLowerCase();
  return !!domain && ALLOWED_EMAIL_DOMAINS.includes(domain);
};

// `hd` accepts only one domain, so "*" limits the picker to Workspace accounts.
// This is only a UI hint — we still verify the email domain after sign-in.
googleProvider.setCustomParameters({ hd: "*" });

export class UnauthorizedDomainError extends Error {
  constructor(email: string | null) {
    const allowed = ALLOWED_EMAIL_DOMAINS.map((d) => `@${d}`).join(" or ");
    super(`Only ${allowed} Google accounts can sign in.${email ? ` (${email})` : ""}`);
    this.name = "UnauthorizedDomainError";
  }
}

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const email = result.user.email ?? "";
    if (!isAllowedEmail(email)) {
      await signOut(auth);
      throw new UnauthorizedDomainError(email || null);
    }
    return result.user;
  } catch (error) {
    console.error("Error signing in with Google", error);
    throw error;
  }
};

export const logOut = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Error signing out", error);
    throw error;
  }
};
